import React from 'react';
import PropTypes from 'prop-types';

import { AlertTypes } from '../constants';
import { T, FONT_MONO, SET_ORDER } from '../constants/tokens';

/**
 * The key beneath the live map.
 *
 * Built from SET_ORDER rather than a hardcoded list, so statuses added to
 * AlertTypeObjs later appear here without another edit.
 */
export default function StatusLegend({ style = {} }) {
  const entries = SET_ORDER
    .map((key) => AlertTypes[key])
    .filter(Boolean)
    .concat(AlertTypes.UNKNOWN);

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px 24px',
        marginTop: 24,
        paddingTop: 24,
        borderTop: '1px solid ' + T.hairlineSoft,
        ...style
      }}
    >
      {entries.map((status) => (
        <span
          key={status.getDashboardStatus()}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            fontFamily: FONT_MONO,
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '16px',
            textTransform: 'uppercase',
            color: T.body
          }}
        >
          {/* 16px, so the key is easy to read at a glance; the faint inset
              ring keeps pale statuses (Normal, All Clear) visible on the card. */}
          <span
            style={{
              width: 16,
              height: 16,
              flex: 'none',
              borderRadius: 9999,
              background: status.getColor().main,
              boxShadow: 'inset 0 0 0 1px rgba(35,37,29,0.18)'
            }}
          />
          {status.getDashboardStatus()}
        </span>
      ))}
    </div>
  );
}

StatusLegend.propTypes = {
  style: PropTypes.object
};
